import { Environment } from './model';

export const environment: Environment = {
  name: 'medical-staging',
  production: false,
  isMedical: true,
  firebase: {
    apiKey: 'AIzaSyCVBN2CGg01K2yxaLVVGyOTSV6T0grzVmM',
    authDomain: 'remedee-medical-staging.firebaseapp.com',
    projectId: 'remedee-medical-staging',
    storageBucket: 'remedee-medical-staging.appspot.com',
    messagingSenderId: '64840593322',
    appId: '1:64840593322:web:87844498fc8af7143085d3',
    measurementId: 'G-YNHETK9PEF',
  },
  functionsRegion: 'europe-west1',
  functionsBaseUrl:
    'https://europe-west1-remedee-medical-staging.cloudfunctions.net',
  reportBaseUrl: 'https://report-staging.remedee.com',
};
